import useDataRequest from './useDataRequest';
import http from 'utils/request';
import qs from 'qs';

/**
 * 查询报告请求 Hook
 * @param {string} id - 报告编号
 * @param {string} name - 委托单位
 */
export const useCheckData = (params) => {
  const paramsString = qs.stringify(params);
  return useDataRequest(
    `checkData`,
    () => http.get('/gwapi/Openservice/report?' + paramsString),
    {
      immediate: false,
      useCache: false,
    },
  );
};
